<template>
  <div class="c-select-label-container">
    <div class="c-select-label c-select-label--pref">
      <div class="c-select-label__title">地域</div>
      <ul class="c-select-label-list">
        <li class="c-select-label-list__item">
          <label class="c-select-label__label">
            <input
              v-model="params.regions"
              type="checkbox"
              name="demogra_pref"
              :value="allValue"
              @change="onRegionAllChange"
            />
            <div class="c-select-label__item">すべて</div>
          </label>
        </li>
        <li
          v-for="(value,index) in regionTypes"
          :key="'demogra-info-region-id-' + value"
          class="c-select-label-list__item"
        >
          <label class="c-select-label__label">
            <input
              v-model="params.regions"
              type="checkbox"
              name="demogra_pref"
              :value="value"
              @change="onRegionChange"
            />
            <div class="c-select-label__item">{{ labels.region[index] }}</div>
          </label>
        </li>
      </ul>
      <div class="c-error c-error--balloon">
        <div class="c-error__text"></div>
      </div>
    </div>

    <div
      class="c-select-label c-select-label--pref c-select-label--pref-detail"
      :class="[{'is-active': filterPrefectures().length > 0}]"
    >
      <div class="c-select-label__title"></div>
      <div class="c-select-label__arrow"></div>
      <ul class="c-select-label-list">
        <li
          v-for="prefecture in filterPrefectures()"
          :key="'demogra-info-prefecture-id-' + prefecture.id"
          class="c-select-label-list__item"
        >
          <label class="c-select-label__label">
            <input
              v-model="params.prefectures"
              type="checkbox"
              name="demogra_pref_detail"
              :value="prefecture.id"
              @change="onPrefectureChange"
            />
            <div class="c-select-label__item">{{ prefecture.name }}</div>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    allValue: { type: [String, Number], required: true },
    initialRegions: { type: Array, required: false },
    initialPrefectures: { type: Array, required: false },
    onChange: { type: Function, required: true },
    prefectureTypes: { type: Array, required: true },
    regionTypes: { type: Object, required: true },
  },
  data() {
    return {
      labels: {
        region: {
          Chubu: '中部',
          Chugoku: '中国',
          Hokkaido: '北海道',
          Kanto: '関東',
          Kinki: '近畿',
          Kyushu: '九州・沖縄',
          Shikoku: '四国',
          Tohoku: '東北',
        },
      },
      params: {
        regions:  (this.initialRegions && Array.isArray(this.initialRegions) && this.initialRegions.length > 0)
          ? this.initialRegions : [],
        prefectures: (this.initialPrefectures && Array.isArray(this.initialPrefectures) && this.initialPrefectures.length > 0)
          ? this.initialPrefectures : [],
      },
    };
  },
  methods: {
    filterPrefectures() {
      //  選択済み地域から、表示対象の都道府県リストを作成
      const prefectures = this.prefectureTypes.filter((prefecture) => {
        // 地域が選択されていない場合: 全ての県を表示しない
        if (this.params.regions.length < 1) return false;

        // 「すべて」ラベルが選択されている場合: 全ての県を表示
        if (this.params.regions.includes(this.allValue)) return true;

        //
        // 選択状態の地域に属する都道府県ではない場合は表示しない
        //
        // 北海道
        if (!this.params.regions.includes(this.regionTypes.Hokkaido)) {
          if (prefecture.id <= 1) return false;
        }
        // 東北
        if (!this.params.regions.includes(this.regionTypes.Tohoku)) {
          if (2 <= prefecture.id && prefecture.id <= 7) return false;
        }

        // 関東
        if (!this.params.regions.includes(this.regionTypes.Kanto)) {
          if (8 <= prefecture.id && prefecture.id <= 14) return false;
        }

        // 中部
        if (!this.params.regions.includes(this.regionTypes.Chubu)) {
          if (15 <= prefecture.id && prefecture.id <= 23) return false;
        }

        // 近畿
        if (!this.params.regions.includes(this.regionTypes.Kinki)) {
          if (24 <= prefecture.id && prefecture.id <= 30) return false;
        }

        // 中国
        if (!this.params.regions.includes(this.regionTypes.Chugoku)) {
          if (31 <= prefecture.id && prefecture.id <= 35) return false;
        }

        // 四国
        if (!this.params.regions.includes(this.regionTypes.Shikoku)) {
          if (36 <= prefecture.id && prefecture.id <= 39) return false;
        }

        // 九州・沖縄
        if (!this.params.regions.includes(this.regionTypes.Kyushu)) {
          if (40 <= prefecture.id) return false;
        }

        return true;
      });

      return prefectures;
    },

    // 全選択・全解除: 地域
    onRegionAllChange: function(_e) {
      //
      // * 「すべて」ラベルを選択した場合は、全ての地域を選択状態に変更
      // * 「すべて」ラベルの選択を外した場合は、全ての地域を未選択状態に変更
      //
      if (this.params.regions.includes(this.allValue)) {
        this.params.regions = [
          this.allValue,
          this.regionTypes.Hokkaido,
          this.regionTypes.Tohoku,
          this.regionTypes.Kanto,
          this.regionTypes.Chubu,
          this.regionTypes.Kinki,
          this.regionTypes.Chugoku,
          this.regionTypes.Shikoku,
          this.regionTypes.Kyushu
        ];
        this.params.prefectures = this.prefectureTypes.map((prefecture) => prefecture.id);
      } else {
        this.params.regions = [];
        this.params.prefectures = [];
      }

      // 親コンポーネントのonChangeイベントを実行
      this.onChange(this.params.regions, this.params.prefectures);
    },

    // 個別選択・個別解除: 地域
    onRegionChange: function(e) {
      // 地域セレクターで選択されていない物を抽出
      const diff  = [
        this.regionTypes.Hokkaido,
        this.regionTypes.Tohoku,
        this.regionTypes.Kanto,
        this.regionTypes.Chubu,
        this.regionTypes.Kinki,
        this.regionTypes.Chugoku,
        this.regionTypes.Shikoku,
        this.regionTypes.Kyushu
      ].filter(value => !this.params.regions.includes(value));

      //
      // * 全選択状態で、すべてラベルが選択済みになっていない場合は、選択状態に変更
      // * 全選択状態ではないのに、すべてラベルが選択済みになっている場合は、選択状態を解除
      //
      if (diff.length < 1 && !this.params.regions.includes(this.allValue)) {
        this.params.regions.push(this.allValue);
      } else if (diff.length > 0 && this.params.regions.includes(this.allValue)) {
        this.params.regions.splice(
          this.params.regions.indexOf(this.allValue),
          1
        );
      }

      // 地域が追加選択された時
      if (e.target.value && this.params.regions.includes(e.target.value)) {
        if (e.target.value == this.regionTypes.Hokkaido && !this.params.prefectures.includes(1)) {
          this.params.prefectures.push(1)
        };
        if (e.target.value == this.regionTypes.Tohoku) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 2 || prefecture.id > 7) return;
            if (this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.push(prefecture.id);
          });
        }
        if (e.target.value == this.regionTypes.Kanto) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 8 || prefecture.id > 14) return;
            if (this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.push(prefecture.id);
          });
        }
        if (e.target.value == this.regionTypes.Chubu) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 15 || prefecture.id > 23) return;
            if (this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.push(prefecture.id);
          });
        }
        if (e.target.value == this.regionTypes.Kinki) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 24 || prefecture.id > 30) return;
            if (this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.push(prefecture.id);
          });
        }
        if (e.target.value == this.regionTypes.Chugoku) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 31 || prefecture.id > 35) return;
            if (this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.push(prefecture.id);
          });
        }
        if (e.target.value == this.regionTypes.Shikoku) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 36 || prefecture.id > 39) return;
            if (this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.push(prefecture.id);
          });
        }
        if (e.target.value == this.regionTypes.Kyushu) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 40) return;
            if (this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.push(prefecture.id);
          });
        }
      }

      // 地域が選択済みリストから除外された時
      if (e.target.value && !this.params.regions.includes(e.target.value)) {
        if (e.target.value == this.regionTypes.Hokkaido && this.params.prefectures.includes(1)) {
          this.params.prefectures.splice(this.params.prefectures.indexOf(1), 1);
        };
        if (e.target.value == this.regionTypes.Tohoku) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 2 || prefecture.id > 7) return;
            if (!this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.splice(this.params.prefectures.indexOf(prefecture.id), 1);
          });
        }
        if (e.target.value == this.regionTypes.Kanto) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 8 || prefecture.id > 14) return;
            if (!this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.splice(this.params.prefectures.indexOf(prefecture.id), 1);
          });
        }
        if (e.target.value == this.regionTypes.Chubu) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 15 || prefecture.id > 23) return;
            if (!this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.splice(this.params.prefectures.indexOf(prefecture.id), 1);
          });
        }
        if (e.target.value == this.regionTypes.Kinki) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 24 || prefecture.id > 30) return;
            if (!this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.splice(this.params.prefectures.indexOf(prefecture.id), 1);
          });
        }
        if (e.target.value == this.regionTypes.Chugoku) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 31 || prefecture.id > 35) return;
            if (!this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.splice(this.params.prefectures.indexOf(prefecture.id), 1);
          });
        }
        if (e.target.value == this.regionTypes.Shikoku) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 36 || prefecture.id > 39) return;
            if (!this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.splice(this.params.prefectures.indexOf(prefecture.id), 1);
          });
        }
        if (e.target.value == this.regionTypes.Kyushu) {
          this.prefectureTypes.forEach((prefecture) => {
            if (prefecture.id < 40) return;
            if (!this.params.prefectures.includes(prefecture.id)) return;
            this.params.prefectures.splice(this.params.prefectures.indexOf(prefecture.id), 1);
          });
        }
      }

      // 親コンポーネントのonChangeイベントを実行
      this.onChange(this.params.regions, this.params.prefectures);
    },

    onPrefectureChange: function() {
      // 親コンポーネントのonChangeイベントを実行
      this.onChange(this.params.regions, this.params.prefectures);
    },

    updateRegions(regions) {
      this.params.regions = regions;
    },

    updatePrefectures(prefectures) {
      this.params.prefectures = prefectures;
    },
  }
}
</script>
